export default __webpack_public_path__ + "static/media/machine-blue.8a990fc7.svg";